import type { Locale } from '@/utils/localeFormatters';

import { formatPercent } from './percentFormat';

/** The settings take their percentages in tenths and halves, so two decimals cover them. */
const MAX_SETTING_DIGITS = 2;

/**
 * A percentage setting as it was entered, "8%" or "2.5%" in en: no padded decimals, so a
 * band reads as the settings dialog shows it.
 */
export function formatSettingPercent(value: number, locale: Locale): string {
    return formatPercent(value, settingDigits(value), { locale });
}

function settingDigits(value: number): number {
    for (let digits = 0; digits < MAX_SETTING_DIGITS; digits += 1) {
        if (Number(value.toFixed(digits)) === value) return digits;
    }
    return MAX_SETTING_DIGITS;
}
